import request from '../request';

export function fetch(params?, options?) {
  return [request, 'get', 'dashboards', params, options];
}

export function create(payload: any) {
  return request('post', 'dashboards', payload);
}

export function update(id: string, payload: any) {
  return request('put', `dashboards/${id}`, payload);
}

export function clone(id: string, payload: any) {
  return request('post', `dashboards/${id}/clone`, payload);
}

export function destroy(id: string) {
  return request('delete', `dashboards/${id}`);
}

export function share(id: string, external_org_id: string) {
  return request('put', `dashboards/${id}/share/${external_org_id}`);
}

export function unshare(id: string) {
  return request('delete', `dashboards/${id}/share`);
}

export function read(id) {
  return [request, 'get', `dashboards/${id}`];
}
